import { render, staticRenderFns } from "./patientInvoicesAll.vue?vue&type=template&id=65466b38&scoped=true"
import script from "./patientInvoicesAll.vue?vue&type=script&lang=js"
export * from "./patientInvoicesAll.vue?vue&type=script&lang=js"
import style0 from "./patientInvoicesAll.vue?vue&type=style&index=0&id=65466b38&prod&lang=scss&scoped=true"
import style1 from "./patientInvoicesAll.vue?vue&type=style&index=1&id=65466b38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65466b38",
  null
  
)

export default component.exports